<template>
  <v-dialog persistent v-model="cashDialog" width="720px">
    <v-card>
      <v-card-title>
          <span class="headline">
            {{ $t("HuifuAccount.Cash.title") }}
          </span>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="cashDialog = false">
              fa-times
            </v-icon>
          </template>
          <span>
              {{ $t("CRUD.backToList", [$t("HuifuAccount.title")]) }}
            </span>
        </v-tooltip>
      </v-card-title>

      <v-card-text>
        <v-container>
           <ValidationObserver ref="observer">
          <v-form>
            <v-row>
              <!-- 汇付账户 -->
              <v-col cols="6">
                  <span >
                    {{ $t("HuifuAccount.Cash.huifuId") + $t("Global.colon") }}
                  </span>
                <span class="green--text">
                  {{ huifuAccount.huifu_id }}
                  </span>
              </v-col>
              <!-- 账户余额 -->
              <v-col cols="6">
                  <span>
                    {{ $t("HuifuAccount.Pay.balanceAmt") }}{{ $t("Global.colon") }}
                  </span>
                <span class="red--text">
                   {{ $t("Global.money") }}{{ balanceAmt | formatMoney }}
                  </span>
              </v-col>
              <!-- 手续费 -->
              <v-col cols="6">
                  <span>
                    {{ $t("HuifuAccount.Cash.feeAmt") }}{{ $t("Global.colon") }}
                  </span>
                <span class="red--text">
                   {{ $t("Global.money") }}{{ 1 | formatMoney }}
                  </span>
              </v-col>
              <!-- 预计到账金额 -->
              <v-col cols="6">
                  <span>
                    {{ $t("HuifuAccount.Cash.expCashAmt") }}{{ $t("Global.colon") }}
                  </span>
                <span class="red--text">
                   {{ $t("Global.money") }}{{ expCashAmt | formatMoney }}
                  </span>
              </v-col>
              <!-- 取现方式-->
              <v-col cols="12">
                  <span>
                    {{ $t("ReceiptDetail.receipt.payment_method") }}{{ $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                      T1
                  </span>
                </v-col>
              <!-- 提现卡号-->
              <v-col cols="12">
                  <ValidationProvider
                          v-slot="{ errors }"
                          :name="$t('HuifuAccount.Cash.cashCard')"
                          rules="required"
                  >
                  <span class="d-flex">
                    {{ $t("HuifuAccount.Cash.cashCard") }}{{ $t("Global.colon") }}
                    <v-select
                            style="padding-top: 0px"
                            v-model="cardSelected"
                            :items="cardItem"
                            :disabled="isCashAmtDisabled"
                            :error-messages="errors"
                            item-text="text"
                            clearable
                    >
                        <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-select>
                  </span>
                  </ValidationProvider>
                </v-col>
              <!-- 提现金额-->
              <v-col cols="6">
                  <ValidationProvider
                          v-slot="{ errors }"
                          :name="$t('HuifuAccount.Cash.cashAmt')"
                          :rules="{
                                    max_value: {
                                        max: parseFloat(balanceAmt).toFixed(2),
                                    },
                                    min_value: {
                                        min: 1.01,
                                    },
                                    required: {
                                        required: true
                                    }
                                }"
                  >
                  <span class="d-flex">
                    {{ $t("HuifuAccount.Cash.cashAmt") }}{{ $t("Global.colon") }}
                    <v-text-field
                            v-model="cashAmt"
                            single-line
                            dense
                            type="number"
                            min="0"
                            :disabled="isCashAmtDisabled"
                            :prefix="$t('Global.money')"
                            :error-messages="errors"
                            @blur="cashAmt = $numberFormatter.formatMoney(cashAmt)"
                    ><template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </span>
                  </ValidationProvider>
              </v-col>
              <!-- 验证码 -->
              <v-col cols="6" v-if="isCashAmtDisabled">
                  <span class="d-flex">
                    {{ $t("HuifuAccount.Pay.VCode") }}{{ $t("Global.colon") }}
                    <v-text-field
                            v-model="VCode"
                            single-line
                            dense
                            persistent-hint
                            :hint="$t('HuifuAccount.vc_code_hint')"
                    />
                  </span>
                </v-col>
            </v-row>
          </v-form>
           </ValidationObserver>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="cashDialog = false">{{ $t("$vuetify.close") }}</v-btn>
          <v-btn color="accent" @click="submit()">{{ $t("CRUD.confirm") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from "@/i18n";
import HfdgInterface from "@/api/hfdgInterface";
import ThirdAccountInfo from "@/api/third-account-info"
import { ValidationObserver, ValidationProvider } from "vee-validate";


export default {
    name: "cashDialog",

    props: {
        value: Boolean,
        cashItem: Object
    },
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data: () => ({
        cashDialog: false,
        huifuAccount: {},
        cashAmt: null,
        balanceAmt: 0,
        expCashAmt: 0,
        cardItem: [],
        cardSelected: null,
        VCode: null,
        cashCode: null,
        isCashAmtDisabled: false,
    }),
    mounted() {

    },
    methods: {
        getBalanceAmt() {
            //获取汇付账户余额
            if (this.huifuAccount.huifu_id) {
                HfdgInterface.getWithdraw({huifu_id: this.huifuAccount.huifu_id}).then((response) => {
                    if (response.data.status.isOK()) {
                        this.balanceAmt = parseFloat(response.data.data[0].balance_amt).toFixed(2);
                        HfdgInterface.getQueryUser({huifu_id: this.huifuAccount.huifu_id}).then((UserResponse) => {
                            if (UserResponse.data.status.isOK) {
                                this.cardItem = UserResponse.data.qry_cash_card_info_list
                                this.cardItem = this.cardItem.map((card) => {
                                    card.text = card.bank_name + ' / ' + card.card_no;
                                    card.value = card.token_no;
                                    return card
                                })
                            }
                        })
                    }
                })
            }
        },
        submit() {
            if (!this.isCashAmtDisabled) {
                this.$refs.observer.validate().then(
                    async function (result) {
                        if (result) {
                            let submitData = {
                                huifu_id: this.huifuAccount.huifu_id,
                                cash_type: 101, // TODO 支付类型：汇付：101（暂时）
                                cash_amt: this.cashAmt,
                                card_token_no: this.cardSelected
                            }
                            ThirdAccountInfo.addHfdgEnchashment(submitData).then((cashResponse) => {
                                if (cashResponse.data.status.isOK()) {
                                    this.cashCode = cashResponse.data.third_cash_records.cash_code
                                    if (cashResponse.data.mobile_validation_flg && cashResponse.data.mobile_validation_code != '') {
                                        let submitData = {
                                            cash_code: this.cashCode,
                                            validation_code: cashResponse.data.mobile_validation_code
                                        }
                                        HfdgInterface.enchashment(submitData).then(
                                            function (response) {
                                                if (response.data.status.isOK()) {
                                                    this.$snackbar.success(i18n.t("HuifuAccount.Cash.successMsg"));
                                                    this.cashDialog = false
                                                }
                                            }.bind(this)
                                        )
                                    } else {
                                        ThirdAccountInfo.mobileValidation({third_record_code: this.cashCode, type: 2}).then((response) => {
                                            if (response.data.status.isOK()) {
                                                this.$snackbar.success(i18n.t("HuifuAccount.Cash.mobileVCode"));
                                                this.isCashAmtDisabled = true
                                            }
                                        })
                                    }
                                }
                            })
                        }
                    }.bind(this)
                )
            }else if (this.VCode != '') {
                let submitData = {
                    cash_code: this.cashCode,
                    validation_code: this.VCode
                }
                HfdgInterface.enchashment(submitData).then(
                    function (response) {
                        if (response.data.status.isOK()) {
                            this.$snackbar.success(i18n.t("HuifuAccount.Cash.successMsg"));
                            this.cashDialog = false
                        }
                    }.bind(this)
                )
            }
        },
    },

    watch: {
        value: {
            immediate: false, //初始赋值也调用
            handler() {
                if (this.value) {
                    this.getBalanceAmt()
                } else {
                    this.huifuAccount = {};
                    this.cashAmt = null;
                    this.balanceAmt = 0;
                    this.expCashAmt = 0;
                    this.cardItem = [];
                    this.cardSelected = null;
                    this.VCode = null;
                    this.cashCode = null;
                    this.isCashAmtDisabled = false;
                    this.$refs.observer.reset();
                }
                this.cashDialog = this.value;
            },
        },
        cashItem: {
            immediate: false, //初始赋值也调用
            handler() {
                this.huifuAccount = this.cashItem;
                if (this.cashItem) {
                    this.getBalanceAmt()
                }
            },
        },
        cashDialog: {
            handler() {
                this.$emit("input", this.cashDialog);
            },
        }
    },
};
</script>